
import './style.css';
import {Map, View} from 'ol';
import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
import TileWMS from 'ol/source/TileWMS';
import LayerSwitcher from 'ol-layerswitcher';
import "ol-layerswitcher/src/ol-layerswitcher.css";
import GeoJSON from 'ol/format/GeoJSON';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import {Circle as CircleStyle,Fill,   RegularShape, Stroke, Style, Text} from 'ol/style';
 
import { Timeline,DataSet } from "vis-timeline/standalone";
import Point from 'ol/geom/Point';
import Layer from 'ol/layer/Layer';
import {fromLonLat} from 'ol/proj.js';
import {getVectorContext} from 'ol/render.js';

import Feature from 'ol/Feature';


import LayerGroup from 'ol/layer/Group';
import Collection from 'ol/Collection';



window.test_var=1

////Strelice _radar 
const source_arr = new VectorSource();

const shaft = new RegularShape({
  points: 2,
  radius: 5,
  stroke: new Stroke({
    width: 2,
  //  color: 'black',
  }),
  rotateWithView: true,
  willReadFrequently: true,
});
const head1 = new RegularShape({
  points: 3,
  radius: 5,
  fill: new Fill({
   // color: 'black',
  }),
  rotateWithView: true,
  willReadFrequently: true,
});
const styles = [new Style({image: shaft}), new Style({image: head1})];
const colorsrange=['#66a06f', '#69a58d', '#75a69e', '#89a4a4', '#a29e9f', '#bd948d', '#d68471', '#ed6c48', '#ff4700']


window.strelice= new VectorLayer({
  title:'Mjerenja Radara',
  source: source_arr,
  style: function (feature) {
    const wind = feature.get('wind');
    //console.log(shaft)
    const angle = ((wind.deg ) * Math.PI) / 180;
    const scale = wind.speed / 10;
    let i_color=Math.floor(scale)
    //console.log(colorsrange[i_color])
    var head1 = new RegularShape({
      points: 3,
      radius: 5,
      fill: new Fill({
        color: colorsrange[i_color],
      }),
      rotateWithView: true,
      willReadFrequently: true,
    });
    var shaft = new RegularShape({
      points: 2,
      radius: 5,
      stroke: new Stroke({
        width: 2,
         color: colorsrange[i_color],
      }),
      rotateWithView: true,
      willReadFrequently: true,
    });
    shaft.setScale([1, scale]);
    shaft.setRotation(angle);
    var styles = [new Style({image: shaft}), new Style({image: head1})];
    head1.setRotation(angle);
    return styles;
  },
  
  visible:false,
})
//strelice.visibilitychanged(function(){console.log('something cgabged')}) 
//strelice.events.register('change', obj, function(obj){console.log(obj)});//
//strelice.on('visibilitychanged',function(){console.log('aaaaaa')})

window.strelice.on('change:visible', function (e) {

 
  if(!e.oldValue){
    document.getElementById('radar_control').style.display='block'

  }
  else{
    document.getElementById('radar_control').style.display='none'

  }
})
var legendDiv = document.createElement('div');
legendDiv.id = 'legend_radar';
document.getElementById('radar_control').appendChild(legendDiv)

// Append the legend div to the document body or any other container
var i=0;
colorsrange.forEach(function (s){

    
    var color=s//#.getImage().getFill().getColor()

    //#console.log(s.getImage().getFill().getColor())
    var item = document.createElement('div');
    item.style.backgroundColor = color;
    item.textContent = i; // You can customize the text based on your requirements
    legendDiv.appendChild(item);
    i++
})
var radar_data=['radar2023-09-13-2000.ruv.json',
'radar2023-09-25-1100.ruv.json']
 

const datum_slider_radar=document.getElementById('radar_datum')//.onchange(function(event){  console.log(event)})

fetch("data/radar_list.json").then(function (response) {
  return response.json();
}
).then(function(response){
  radar_data=response.list

  datum_slider_radar.setAttribute('min',0)

  datum_slider_radar.setAttribute('max',radar_data.length)

var radar_time_ticks=document.getElementById('radar_time_ticks')
var step=Math.floor(radar_data.length/3)
for(  var i=0;i<radar_data.length;i+=step){
  //console.log(i)
  //console.log(radar_data[i].substring(5,15))
 let  span1=document.createElement('span')
  span1.innerHTML=radar_data[i].substring(5,15).replaceAll('-','.')+'.'
  radar_time_ticks.appendChild(span1)
}


})


function retrieve_appropriate_radar_data(f_name='data/radar.json'){
 fetch(f_name)
  .then(function (response) {
    return response.json();
  })
  .then(function (jdata) {
    source_arr.clear()
    const features = [];

    jdata.list.forEach(function (pp) {
      
      const feature = new Feature(
           new Point(fromLonLat([ pp.coord.lon,pp.coord.lat]))
      );
      feature.setProperties(pp);
      features.push(feature);
    });
    source_arr.addFeatures(features);
  });

}
datum_slider_radar.onchange=function() {

  var radar_index=datum_slider_radar.value
 // console.log(radar_index)
  var f=radar_data[radar_index]
  //console.log('data/radar_video/'+f)
  document.getElementById('radar_datum_value').innerHTML=f.substring(5,20)
  retrieve_appropriate_radar_data('data/radar_video/'+f)

}


var i=0
var ply_radar=false
const playBtn=document.getElementById('play_radar')
playBtn.innerHTML='<img class="but_video" src="image/play.png" >'

function playFn(){
 // console.log('play')
  var item_radar=datum_slider_radar.value
  //console.log(item_radar)
  datum_slider_radar.value++
 
  var event = new Event('change');

// Dispatch it.
datum_slider_radar.dispatchEvent(event);

}
var int_id=0
playBtn.onclick= function (properties) {
  
 if (!ply_radar){
  ply_radar=true
  int_id=setInterval(playFn,1000)
  playBtn.innerHTML='<img class="but_video" src="image/pause.png" >'

 }
 else{
  ply_radar=false
  clearInterval(int_id)
  playBtn.innerHTML='<img class="but_video" src="image/play.png" >'

 }

}


//console.log('radar gotov')